import React, { useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./Home.css";
import { Navbar } from "../../components/Navbar/Navbar";
import Hero from "../../components/Hero/Hero";
import Occasions from "../../components/Occasions/Occasions";
import { Contact } from "../../components/Contact/Contact";
import Footer from "../../components/Footer/Footer";
import { Helmet } from "react-helmet-async";

const Home = () => {
	const contactRef = useRef(null);
	const location = useLocation();

	const scrollToContact = () => {
		contactRef.current?.scrollIntoView({ behavior: "smooth" });
	};

	useEffect(() => {
		const params = new URLSearchParams(location.search);
		if (params.get("scrollTo") === "contact") {
			setTimeout(() => {
				contactRef.current?.scrollIntoView({ behavior: "smooth" });
			}, 300);
		}
	}, [location.search]);

	return (
		<>
			<Helmet>
				<title>
					Aire Studio - Balloon Bouquets, Gift Baskets & Balloon Arches
				</title>
				<meta
					name="description"
					content="Bespoke balloon bouquets, curated gift baskets, and stunning balloon arches crafted for life's most beautiful moments."
				/>
				<meta
					name="keywords"
					content="balloon bouquets, gift baskets, balloon arches, wedding balloons, birthday balloons, custom gifts, party balloons"
				/>
				<link rel="canonical" href="/" />
			</Helmet>

			<div className="home">
				<Navbar onContactClick={scrollToContact} />
				<Hero onContactClick={scrollToContact} />
				<Occasions />
				<Contact ref={contactRef} />
				<Footer />
			</div>
		</>
	);
};

export default Home;
